<template>
  <div class="edit-gift">
    <headerNotice routerName="编辑积分礼品"></headerNotice>
    <div v-loading='loading' class="content">
      <el-form
        ref="form"
        style="margin-left: 28% ;"
        :rules="rules"
        :model="form"
        label-width="150px"
      >
        <el-form-item label="礼品名称: " prop="title">
          <el-input class="input-el" v-model="form.title" placeholder="请输入礼品名称"></el-input>
        </el-form-item>
        <el-form-item label="礼品分类: " prop="cateID">
          <el-select v-loading='opLoading' v-model="form.cateID" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.cateName"
              :label="item.cateName"
              :value="item.cateID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="礼品图片: " prop="fileName" ref='fileName'>
          <el-upload
            :accept='accept'
            class="upload"
            :action="uploadAction"
            :headers="headers"
            :on-success="upImgsSuccess"
            :file-list="imagesList"
            list-type="picture-card"
            :before-upload="beforeUpload"
            :on-remove="imgsRemove"
            :limit="5"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-upload"></i>
            <span>选择上传文件</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="礼品数量: " prop="stock">
          <el-input class="input-el" v-model.number="form.stock" placeholder="请输入数值" type='number'>
            <template slot="append">件</template>
          </el-input>
        </el-form-item>
        <el-form-item label="市场销售价: " prop="disPoints">
          <el-input class="input-el" v-model.number="form.disPoints" placeholder="请输入金额" type='number'>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="成本价: " prop="costPrice">
          <el-input class="input-el" v-model.number="form.costPrice" placeholder="请输入金额" type='number'>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="兑换所需积分: " prop="integral">
          <el-input class="input-el" v-model.number="form.integral" placeholder="请输入数值" type='number'>
            <template slot="append">积分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="每人最多兑换数量: " prop="maxExchangeNum">
          <el-input class="input-el" v-model.number="form.maxExchangeNum" placeholder="为空不限制" type='number'>
            <template slot="append">件</template>
          </el-input>
        </el-form-item>
        <el-form-item label="已兑换数量: " prop="changeNum">
          <el-input class="input-el" v-model.number="form.changeNum" placeholder="请输入数值" type='number'>
            <template slot="append">件</template>
          </el-input>
        </el-form-item>
        <el-form-item label="兑换说明: " prop="explain">
          <el-input
            :rows='4'
            resize="none"
            type="textarea"
            class="input-el"
            v-model="form.explain"
            placeholder="请输入兑换说明"
            maxlength='300'
            ></el-input>
        </el-form-item>
        <p class='tips'>{{'已输入' + form.explain.length + ' / 300'}}</p>
        <el-form-item label="礼品详情: " prop="descripImages" ref='descripImages'>
          <el-upload
            :accept='accept'
            class="upload"
            :action="uploadAction"
            :headers="headers"
            :on-success="upImgsDescSuccess"
            :file-list="imagesDescList"
            list-type="picture-card"
            :before-upload="beforeUpload"
            :on-remove="imgsDescRemove"
            :limit="5"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-upload"></i>
            <span>选择上传文件</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="礼品排序: " prop="sort">
          <el-input class="input-el" v-model.number="form.sort" placeholder="请输入礼品序号">
          </el-input>
        </el-form-item>
        <el-form-item label="上架/下架: " prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-left: 10%;">
          <el-button :loading="loading" @click="submit" type="primary">提交</el-button>
          <el-button @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  data() {
    var hasImg = (rule, value, callback) => {
      if (!this.form.fileName.length) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var hasDescImg = (rule, value, callback) => {
      if (!this.form.descripImages.length) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var isInt = (rule, value, callback) => {
      if(/^(([0-9]*[1-9][0-9]*)|(0))$/.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的数量"));
      }
    };
    var isPricre = (rule, value, callback) => {
      if(this.isMoney(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的金额"));
      }
    }
    var maxExchange = (rule, value, callback) => {
      if(this.isMoney(value) || value === '') {
        callback();
      } else {
        callback(new Error("请输入正确的金额"));
      }
    }
    return {
      loading: false,
      opLoading: false,
      rules: {
        title: { required: true, message: "请输入礼品名称", trigger: "change" },
        cateID: {  required: true, message: "请选择礼品类型", trigger: "change" },
        fileName: { required: true, validator: hasImg, trigger: "change" },
        stock: { required: true, validator: isInt, trigger: "change" },
        disPoints: { required: true, validator: isPricre, trigger: "change" },
        costPrice: { required: true, validator: isPricre, trigger: "change" },
        integral: { required: true, validator: isInt, trigger: "change" },
        maxExchangeNum: { validator: maxExchange, trigger: "change" },
        changeNum: { required: true, validator: isInt, trigger: "change" },
        explain: { required: true, message: "请输入少于300字的说明", trigger: "change" },
        descripImages: { required: true, validator: hasDescImg, trigger: "change" },
        status: { required: true, message: "请勾选商品状态", trigger: "change"  },
        sort: { required: true, validator: isInt, trigger: "change"  }
      },
      form: {
        title: "",
        cateID: "",
        stock: "",
        fileName: [],
        disPoints: '',
        costPrice: '',
        integral: '',
        maxExchangeNum: '',
        explain: '',
        descripImages: [],
        status: ''
      },
      options: [],
      accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
      headers: {
        Authorization: localStorage.getItem("accessToken")
      },
      // headers: {
      //   'Authorization': sessionStorage.getItem('accessToken'),
      // }, //正式头部
      uploadAction:
        this.$store.state.apiUrl + "/api/services/app/Image/UploadImage",
      imagesList: [],
      imagesDescList: [],
      baseUrl: this.$store.state.apiUrl,
      itemID: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    submit(formName) {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.form)
          // this.$emit("sendData", this.form, this.type);
          this.updateIntegralItem(this.form)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    back() {
      this.$router.push({
        path: '/giftList'
      })
    },
    // 编辑商品
    updateIntegralItem(formData) {
      let data = Object.assign({}, formData)
      data.maxExchangeNum = Number(data.maxExchangeNum)
      data.itemID = this.$route.query.itemID
      if(data.disPoints < 1) {
        this.$message.error('市场销售价不能少于1元')
        return
      }
      if(data.costPrice < 1) {
        this.$message.error('成本价不能少于1元')
        return
      }
      let self = this;
      // self.loading = true
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/UpdateIntegralItem",
        data: data,
        success(res) {
          // console.log(res);
          // self.giftList = self.dealGiftData(res.items)
          // self.loading = false
          self.$message.success('操作成功！')
          self.$router.push({
            path: '/giftList'
          })
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 礼品图片
    upImgsSuccess(response, file, fileList) {
      this.form.fileName.push(response.result.fileName);
      this.imagesList.push({
        name: response.result.fileName,
        url: this.baseUrl + response.result.url
      });
      this.$refs.fileName.clearValidate()
    },
    imgsRemove(file, fileList) {
      this.imagesList = fileList;
      this.form.fileName = []
      this.imagesList.forEach((item) => {
        this.form.fileName.push(item.name)
      })
    },
    // 礼品描述
    upImgsDescSuccess(response, file, fileList) {
      this.form.descripImages.push(response.result.fileName);
      this.imagesDescList.push({
        name: response.result.fileName,
        url: this.baseUrl + response.result.url
      });
      this.$refs.descripImages.clearValidate()
    },
    imgsDescRemove(file, fileList) {
      this.imagesDescList = fileList;
      this.form.descripImages = []
      this.imagesDescList.forEach((item) => {
        this.form.descripImages.push(item.name)
      })
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (file.type != "image/jpeg" && file.type != "image/png") {
        this.$message.error("上传的图片只支持JPG/PNG 的格式!");
        return false;
      }
      return true;
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10M!");
      }
      return isLt10M;
    },
    handleExceed() {
      this.$message.error("抱歉，最多上传五张图片！");
    },
    isMoney(money) {
      return /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(money);
    },
    // 获取分类
    getIntegralItemCate(params) {
      let self = this;
      self.opLoading = true
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetIntegralItemCate",
        params: params,
        success(res) {
          // console.log(res);
          self.opLoading = false
          self.options = res
        },
        fail(res) {
          self.opLoading = false
        }
      });
    },
    // 获取详情
    getAdminUpdateIntegralItem(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetAdminUpdateIntegralItem",
        params: params,
        success(res) {
          // console.log(res);
          self.form = res
          if(!self.form.explain) {
            self.form.explain = ''
          }
          if(self.form.maxExchangeNum == 0) {
            self.form.maxExchangeNum = ''
          }
          self.dealFileName(res.fileName)
          self.dealDescripImages(res.descripImages)
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    dealFileName(data) {
      let temp = []
      let temp2 = []
      data.forEach((item) => {
        let name = item.fileName
        temp.push(name)
        temp2.push({
          name: name,
          url: this.baseUrl + item.url
        })
      })
      this.form.fileName = temp
      this.imagesList = temp2
      // console.log(this.form.fileName,this.imagesList)
    },
    dealDescripImages(data) {
      let temp = []
      let temp2 = []
      data.forEach((item) => {
        let name = item.fileName
        temp.push(name)
        temp2.push({
          name: name,
          url: this.baseUrl + item.url
        })
      })
      this.form.descripImages = temp
      this.imagesDescList = temp2
    }
  },
  created() {
    this.getIntegralItemCate()
    this.getAdminUpdateIntegralItem({
      ItemID: this.$route.query.itemID
    })
    this.itemID = this.$route.query.itemID
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.edit-gift {
  .content {
    padding: 20px 50px 0;
  }
  .tips {
    margin: -10px 0 12px 13%;
    color: #999;
    font-size: 12px;
  }
  .upload {
    width: 500px;
    // border: 1px solid #e4e4e4;
    // border-radius: 4px;
  }
  .input-el {
    width: 460px;
  }
}
</style>